export function filterMap<T>(
  array: T[],
  predicate: (value: T, indx: number, array: Array<T>) => boolean,
  mapCallbackfn: (value: T, array: Array<T>) => any,
  innerTapFn?: (value: any, index: number, array: any[]) => void
): Array<any> {
  const newArray = [];
  for (let i = 0; i < array.length; i++) {
    if (predicate(array[i], i, array)) {
      const newMappedItem = mapCallbackfn(array[i], array);
      if (innerTapFn && Array.isArray(newMappedItem)) {
        newMappedItem.forEach(innerTapFn);
      }
      newArray.push(newMappedItem);
    }
  }
  return newArray;
}
